<template>
    <div>
        <loading :show="show" :label="label"></loading>
        <div class="modal fade" id="dataQuality" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document" id="ol">
                <div class="modal-content box-shadow">
                    <div v-if="result.nse != 'X'" class="modal-body sizeModalData">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" @click="closeDataQuality">&times;</span>
                        </button>

                        <div class="row center">
                            <div class="text-center mb-2">
                                <div class="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true" title="Socioeconómico">
                                        <span class="geodir-icon-dollar"></span>
                                    </a>

                                    <a class="nav-link" id="v-pills-messages-tab" data-toggle="pill" href="#v-pills-messages" role="tab" aria-controls="v-pills-messages" aria-selected="false" title="Negocios">
                                        <span class="geodir-icon-building"></span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="">
                            <div class="tab-content" id="v-pills-tabContent">
                                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                    <div class="nse mb-2 text-center">
                                        <fieldset class="dhhBorder" v-if="typeof result.nse == 'string' && result.nse.length > 0">
                                            <legend class="dhhBorder">NSE</legend>
                                            <img :src="getImage('nse-' + result.nse.toLowerCase() + '.png')" width="130" height="170" class="logo mb-2" data-toggle="tooltip" data-placement="right" title="NSE">
                                        </fieldset>
                                        
                                        <fieldset class="dhhBorder" v-if="typeof result.nse == 'object'">
                                            <legend class="dhhBorder">NSE: {{result.count.toLocaleString()}} Manzanas</legend>
                                            <div id="nsecharts"></div>
                                        </fieldset>
                                    </div>
                                    
                                    <div class="row text-center justify-content-around">
                                        <div class="col-md-6 mb-2">
                                            <fieldset class="dhhBorder">
                                            <legend class="dhhBorder">Personas</legend>
                                            <img :src="getImage('population.png')" width="75" height="70" class="mb-3 mt-2" data-toggle="tooltip" data-placement="right" title="Personas">
                                            <h4>{{result.personas.toLocaleString()}}</h4>
                                            </fieldset>
                                        </div>
                                        
                                        <div class="col-md-6 house mb-2">
                                            <fieldset class="dhhBorder">
                                            <legend class="dhhBorder">Viviendas (Predios)</legend>
                                            <img :src="getImage('house.png')" width="75" height="70" class="mb-3 mt-2" data-toggle="tooltip" data-placement="right" title="Viviendas">
                                            <h4>{{result.viviendas.toLocaleString()}}</h4>
                                            </fieldset>
                                        </div>
                                    </div>
                                    
                                    <div class="row text-center justify-content-around">
                                        <div class="col-md-6 nse mb-2">
                                            <fieldset class="dhhBorder">
                                            <legend class="dhhBorder">Rango de Edades (años)</legend>
                                            <div id="rangocharts"></div>
                                            </fieldset>
                                        </div>
                                        
                                        <div class="col-md-6 mb-2">
                                            <fieldset class="dhhBorder">
                                            <legend class="dhhBorder">Género</legend>
                                            <div class="row genero justify-content-center">
                                                <div class="col-md-5 ">
                                                    <img :src="getImage('women.png')" width="80" height="70" class="mb-3 mt-2" data-toggle="tooltip" data-placement="right" title="Mujeres">
                                                    <h4 class="mb-2">{{result.mujeres.toLocaleString()}}</h4>     
                                                </div>
                                                
                                                <div class="col-md-5">
                                                    <img :src="getImage('men.png')" width="85" height="70" class="mb-3 mt-2" data-toggle="tooltip" data-placement="right" title="Varones">
                                                    <h4 class="mb-2">{{result.hombres.toLocaleString()}}</h4>  
                                                </div>
                                            </div>                                            
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>                           

                                <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab"> 
                                    <business :data="result"></business>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else class="modal-body sizeModalData">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true" @click="closeDataQuality">&times;</span>
                        </button>

                        <div class="row center">
                            <div class="text-center mb-2">
                                <div class="nav nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                    <a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true" title="Socioeconómico">
                                        <span class="geodir-icon-dollar"></span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="">
                            <div class="tab-content" id="v-pills-tabContent">
                                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                                    <div class="nse mb-2 text-center">
                                        <fieldset class="dhhBorder" v-if="typeof result.nse == 'string' && result.nse.length > 0">
                                            <legend class="dhhBorder">NSE</legend>
                                            <img :src="getImage('nse-' + result.nse.toLowerCase() + '.png')" width="130" height="170" class="logo mb-2" data-toggle="tooltip" data-placement="right" title="NSE">
                                        </fieldset>
                                    </div>                                                                       
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from 'vue-full-loading'
    import Business from './Business'

    var GeodirDataQuality = require('@geodir/geodir-js/src/GeodirDataQuality')
    var ghDataQuality = new GeodirDataQuality({key:'c7fab301-31d8-4618-b452-bc82e361d9bf'})

    import { mapState, mapMutations } from 'vuex'
    
    export default {
        components: {
            Loading,
            Business
        },
        data() {
            return {
                params: {
                    time_limit: 600
                },
                result: {
                    "id": "",
                    "nse": "",
                    "viviendas": 0,
                    "hogares": 0,
                    "personas": 0,
                    "hombres":"0",
                    "mujeres":"0",
                    "edad_0_5":"",
                    "edad_6_11":"",
                    "edad_12_17":"",
                    "edad_18_29":"",
                    "edad_30_59":"",
                    "edad_60":"",
                    "ingresos": 0,
                    "gastos": 0,
                    "grupo_1": 0,
                    "grupo_2": 0,
                    "grupo_3": 0,
                    "grupo_4": 0,
                    "grupo_5": 0,
                    "grupo_6": 0,
                    "grupo_7": 0,
                    "grupo_8": 0,
                    "geojson":{}
                },
                dataQualityLayer: null,
                inprogress: false,
                message:'',
                show: false,
                label: ''
            };
        },
        mounted() {
            this.initDataQuality();
        },
        computed: {
            ...mapState(['map'])
        },
        methods: {
            closeDataQuality(){
                var comp = this;
                comp.dataQualityLayer.clearLayers();
            },
            initDataQuality() {
                var _startDataQuality = {
                    text: 'Data Quality',
                    icon: this.getImage('data-icon.png'),
                    callback: this.iniciarDataQuality,
                    index: 1
                };
                //this.menuDataQuality = this.map.contextmenu.insertItem(_startDataQuality, _startDataQuality.index);
            },
            iniciarDataQuality(e) {
                var new_point = encodeURIComponent('{"type":"Point","coordinates":['+e.latlng.lng+','+e.latlng.lat+']}');

                var comp = this;
                comp.show = true;
                comp.params.point = new_point;

                if (!comp.inprogress) {
                    comp.inprogress = true;
                    comp.message = "Calculando ...";
                    ghDataQuality.doRequest(comp.params)

                    .then(function(resultado) {

                        let json = resultado[0];

                        if (comp.dataQualityLayer){
                            comp.dataQualityLayer.clearLayers();}

                            comp.result = json;

                            var geojsonMarkerOptions = {
                                radius: 8,
                                fillColor: "#FF0000",
                                color: "#000",
                                weight: 1,
                                opacity: 1,
                                fillOpacity: 0.8
                            };

                            comp.dataQualityLayer = L.geoJson(JSON.parse(json.geojson), {
                                style: function(feature) {
                                    var num = feature.properties.bucket;

                                    if (num != undefined) {
                                        var color = num % 2 === 0 ? "#00cc33" : "blue";
                                        return {color: color,weight: num + 2,opacity: 0.6};
                                    }
                                },

                                pointToLayer: function(feature, latlng) {
                                    return L.circleMarker(latlng, geojsonMarkerOptions);
                                }
                            });



                            var marker = L.marker(e.latlng);
                            comp.dataQualityLayer.addData(marker.toGeoJSON());
                            comp.map.addLayer(comp.dataQualityLayer);
                            comp.message = "Ok";
                            comp.show = false;
                            $('#dataQuality').modal({
                                show: true,
                                backdrop: false
                            });
                            comp.inprogress = false;
                            comp.rangoCharts();

                            const mult = 1.0;
                            $('#dataQuality').draggable({
                                drag: function(event, ui) {
                                    ui.position.top += (ui.offset.top - ui.originalPosition.top) * mult;
                                    ui.position.left += (ui.offset.left - ui.originalPosition.left) * mult;
                                }
                            });                         
                    })

                    .catch(function(err) {
                        comp.inprogress = false;
                        comp.show = false;
                        comp.message = "Ocurrio un error (" + err.message+")";
                    });

                } else {
                    comp.message="Por favor espera. Cálculo en progreso ...";
                }
            },
            iniciarDataQualitybatch(polygon) {
                var comp = this;
                comp.show = true;

                if (!comp.inprogress) {
                    comp.inprogress = true;
                    comp.message = "Calculando ...";
                    comp.params.polygon = polygon;
                    ghDataQuality.batch(comp.params)

                    .then(function(json) {
                        if (comp.dataQualityLayer)
                            comp.dataQualityLayer.clearLayers();
                            comp.result = json;

                            var geojsonMarkerOptions = {
                                radius: 8,
                                fillColor: "#FF0000",
                                color: "#000",
                                weight: 1,
                                opacity: 1,
                                fillOpacity: 0.8
                            };
                            
                            comp.dataQualityLayer = L.geoJson(json.polygon.features, {
                                pointToLayer: function(feature, latlng) {
                                    return L.circleMarker(latlng, geojsonMarkerOptions);
                                }
                            });
                            
                            comp.map.addLayer(comp.dataQualityLayer);
                            comp.message = "Ok";
                            comp.show = false;
                            
                            $('#dataQuality').modal('show');
                            comp.inprogress = false;
                            comp.nseCharts();
                            comp.rangoCharts();
                            
                            const mult = 1.0;
                            $('#dataQuality').draggable({
                                drag: function(event, ui) {
                                    ui.position.top += (ui.offset.top - ui.originalPosition.top) * mult;
                                    ui.position.left += (ui.offset.left - ui.originalPosition.left) * mult;
                                }
                            });                            
                    })

                    .catch(function(err) {
                        comp.inprogress = false;
                        comp.show = false;
                        comp.message = "Ocurrio un error (" + err.message+")";
                    });

                } else {
                    comp.message="Por favor espera. Cálculo en progreso ...";
                }
            },
            nseCharts: function() {
                var comp = this;

                var nseCharts = AmCharts.makeChart( "nsecharts", {
                    "hideCredits":true,
                    "type": "pie",
                    "balloonText": "<span style='font-size:12px'><b>[[title]]:</b><br><b>[[value]]</b> </span>",
                    "innerRadius": 11,
                    "labelRadius": -25,
                    "labelText": "[[percents]]%",
                    "percentPrecision": 1,
                    "hideLabelsPercent": 10,
                    "radius": 65,
                    "fontSize": 9,
                    "color": "#000000",
                    "titleField": "title",
                    "valueField": "value",
                    "allLabels": [],
                    "balloon": {},
                    "legend": {
                        "enabled": true,
                        "align": "center",
                        "markerType": "circle",
                        "labelText": "[[title]]",
                        "position": "right",
                        "valueText": "",
                        "fontSize": 9,
                        "markerSize": 8,
                        "autoMargins": false,
                    },
                    "titles": [],
                    "dataProvider": [ {
                        "title": "Alto",
                        "value": comp.result.nse.a
                    }, {
                        "title": "Medio Alto",
                        "value": comp.result.nse.b
                    }, {
                        "title": "Medio",
                        "value": comp.result.nse.c
                    }, {
                        "title": "Medio Bajo",
                        "value": comp.result.nse.d
                    }, {
                        "title": "Bajo",
                        "value": comp.result.nse.e
                    }, {
                        "title": "Sin Estrato",
                        "value": comp.result.nse.x
                    }]
                }, 0);
            },
            rangoCharts: function() {
                var comp = this;

                var rangoCharts = AmCharts.makeChart( "rangocharts", {
                    "hideCredits":true,
                    "type": "pie",
                    "balloonText": "<span style='font-size:12px'><b>[[title]]:</b><br><b>[[value]]</b> </span>",
                    "innerRadius": 12,
                    "labelRadius": -25,
                    "labelText": "[[percents]]%",
                    "percentPrecision": 1,
                    "hideLabelsPercent": 10,
                    "radius": 60,
                    "fontSize": 9,
                    "color": "#000000", 
                    "titleField": "title",
                    "valueField": "value",
                    "allLabels": [],
                    "balloon": {},
                    "pieX": '32%',
                    "legend": {
                        "enabled": true,
                        "align": "left",
                        "labelText": "[[title]]",
                        "position": "absolute",
                        "valueText": "",
                        "fontSize": 9,
                        "markerSize": 7,
                        "autoMargins": false,
                        "maxColumns": 1,
                        "left": 150,
                        "top": -5
                    },
                    "titles": [],
                    "dataProvider": [ {
                        "title": "0-5",
                        "value": comp.result.edad_0_5
                    }, {
                        "title": "6-11",
                        "value": comp.result.edad_6_11
                    }, {
                        "title": "12-17",
                        "value": comp.result.edad_12_17
                    }, {
                        "title": "18-29",
                        "value": comp.result.edad_18_29
                    }, {
                        "title": "30-59",
                        "value": comp.result.edad_30_59
                    }, {
                        "title": "60 a más",
                        "value": comp.result.edad_60
                    } ]
                }, 0);
            },
            getImage(val) {
                return require('@/assets/images/dataquality/nse/' + val);
            }
        }

    };
</script>

<style scoped>
    .modal-content {
        width: 540px;
    }
    .modal-body {
        width: 540px;
    }
    .sizeModalData {
        height: 100%;
    }
    #myTab .nav-link.active {
        color: #ffffff;
        background-color: #2164f9;
        border-color: #dee2e6 #dee2e6 #fff;
        border-radius: 5px;
    }
    #myTab a:hover {
        border-color: #Fff!important;
    }
    #myTab {
        border: none !important;
    }
    .nav-link {
        width: 150px;
    }
    .box-shadow {
        border:none !important;
        box-shadow: 0 6px 10px rgba(0,0,0,0.2);
    }
    #ol {
        z-index: 1000;
    }
    .tab-pane.active {
        background: #fff;
    }
    .nav-tabs span:before {
        font-size:45px;
    }
    .im {
        font-size: 17px;
        color: #010065;
    }
    .gm {
        font-size: 17px;
        color: #7f9dc3;
    }
    tbody.quality {        
        font-size: 16px;
        color: #7f9dc3;
        padding-left: 10px;
    }
    .quality tr td:nth-child(2) {
        text-align: right;
    }
    fieldset.dhhBorder {
        border: 1px solid #eee;
        margin: 0 0 15px 0;
        box-shadow: 0 6px 10px rgba(0,0,0,0.2);
        border-radius: 5px;
    }
    legend.dhhBorder {
        font-size: 13px;
        color:#2164f9;
        text-align: left;
        width: auto;
        padding: 0 10px;
        border-bottom: none;
        margin-bottom: 0px;
        text-transform: capitalize;
    }
    #nsecharts {
        width: 240px;
        height: 175px;
        font-size: 10px;
        margin: auto;
    }
    #rangocharts {
        margin: 0px 0px 0px 15px;
        width: 86%;
        height: 160px;
        font-size: 10px;
    }
    .tab-pane {
        height: 572px; 
    }
    .tab-pane table {
        margin-left: 0px !important; 
    }
    .tables {
        max-height: 400px !important;
        height: auto;
        overflow-y: auto;
    }
    .center {
        margin: 0px !important;
    }
    .genero span:before {
        font-size: 70px;
        margin:20px 0px;
    }
    @media (min-width: 760px) {
        .accessibility {
            margin-left: -120px;
        }
    }

    @media (max-width: 360px) {
        .modal-content {
            width: 100%;
            height: 1170px;
        }
        .modal-body {
            width: 100%;
        }
    }    
</style>
